// extracted by mini-css-extract-plugin
export default {"colDivisao":"TotaisGeral_colDivisao__px-om","icone":"TotaisGeral_icone__U5kju","tooltipInfo":"TotaisGeral_tooltipInfo__W8Kxw"};